import {
  commonURL,
  commonV2URL,
  commonV3URL,
  errorMessage,
  commonBureauURL
} from 'src/constantsMessage/index';
import helperAxios from 'src/utils/helperAxios';
import moment from 'moment';
import { SET_ALERT } from 'src/actions/alertAction';

export const GET_TRANSACTIONS = '@accountAnalysis/get-transactions';
export const GET_BANKS = '@accountAnalysis/get-banks';
export const GET_TRANSACTIONS_ERROR = '@accountAnalysis/get-transactions_error';
export const GET_TRANSACTIONS_EMPTY = '@accountAnalysis/get-transactions_empty';
export const GET_SUSPICIOUS_ACTIVITY =
  '@accountAnalysis/get-suspicious_activity';
export const GET_SUSPICIOUS_ACTIVITY_EMPTY =
  '@accountAnalysis/get-suspicious_activity_empty';
export const GET_BOUNCED_CHEQUE_EMPTY =
  '@accountAnalysis/get-bounced_cheque_empty';
export const EMPTY_DATA = '@accountAnalysis/get-emty-data';
export const GET_BOUNCED_CHEQUE = '@accountAnalysis/get-bounced-cheque';
export const GET_BOUNCED_CHEQUE_ERROR =
  '@accountAnalysis/get-bounced-cheque-error';
export const GET_SUSPICIOUS_ACTIVITY_ERROR =
  '@accountAnalysis/get-suspicious_activity_error';
export const LOADER = '@accountAnalysis/loader';
export const LOADER_BUREAU = '@accountAnalysis/loader-bureau';
export const GET_ACCOUNT_OVERVIEW = '@accountAnalysis/get-overview';
export const GET_ACCOUNT_OVERVIEW_ERROR = '@accountAnalysis/get-overview-error';
export const GET_ACCOUNT_OVERVIEW_EMPTY = '@accountAnalysis/get-overview-empty';
export const GET_DAILY_BALANCE = '@accountAnalysis/get-DAILY_BALANCE';
export const GET_DAILY_BALANCE_ERROR =
  '@accountAnalysis/get-DAILY_BALANCE-error';
export const GET_DAILY_BALANCE_EMPTY =
  '@accountAnalysis/get-DAILY_BALANCE-empty';
export const GET_TRANSACTION_SUMMARY =
  '@accountAnalysis/get-TRANSACTION_SUMMARY';
export const GET_TRANSACTION_SUMMARY_ERROR =
  '@accountAnalysis/get-TRANSACTION_SUMMARY-error';
export const GET_TRANSACTION_SUMMARY_EMPTY =
  '@accountAnalysis/get-TRANSACTION_SUMMARY-empty';
export const GET_CLOSING_BALANCE = '@accountAnalysis/get-CLOSING_BALANCE';
export const GET_CLOSING_BALANCE_ERROR =
  '@accountAnalysis/get-CLOSING_BALANCE-error';
export const GET_CLOSING_BALANCE_EMPTY =
  '@accountAnalysis/get-CLOSING_BALANCE-empty';
export const GET_CIRCULAR_TRANSACTIONS =
  '@accountAnalysis/get-circulat-transactions';
export const GET_CIRCULAR_TRANSACTIONS_EMPTY =
  '@accountAnalysis/get-circulat-transactions-empty';
export const GET_CIRCULAR_TRANSACTIONS_ERROR =
  '@accountAnalysis/get-circulat-transactions-error';
export const GET_INTRA_BANK_FUND_TRANSFER =
  '@accountAnalysis/get-intra-bank-fund-transfer';
export const GET_INTRA_BANK_FUND_TRANSFER_EMPTY =
  '@accountAnalysis/get-intra-bank-fund-transfer-empty';
export const GET_INTRA_BANK_FUND_TRANSFER_ERROR =
  '@accountAnalysis/get-intra-bank-fund-transfer-error';
export const GET_CASH_FLOW = '@accountAnalysis/get-cashFlow';
export const GET_CASH_FLOW_ERROR = '@accountAnalysis/get-cashFlow-error';
export const GET_CASH_FLOW_EMPTY = '@accountAnalysis/get-cashFlow-empty';
export const GET_CASH_FLOW_ANALYSIS = '@accountAnalysis/get-cashFlowAnalysis';
export const GET_CASH_FLOW_ANALYSIS_ERROR =
  '@accountAnalysis/get-cashFlowAnalysis-error';
export const GET_CASH_FLOW_ANALYSIS_EMPTY =
  '@accountAnalysis/get-cashFlowAnalysis-empty';
export const GET_LOAN_ANALYSIS = '@accountAnalysis/get-loanAnalysis';
export const GET_LOAN_ANALYSIS_ERROR =
  '@accountAnalysis/get-loanAnalysis-error';
export const GET_LOAN_ANALYSIS_EMPTY =
  '@accountAnalysis/get-loanAnalysis-empty';
export const GET_RECCURING_PAYMENTS = '@accountAnalysis/get-recurring-payments';
export const GET_RECCURING_PAYMENTS_ERROR =
  '@accountAnalysis/get-recurring-payments-error';
export const GET_RECCURING_PAYMENTS_EMPTY =
  '@accountAnalysis/get-recurring-payments-empty';
export const GET_RECCURING_DEPOSITS = '@accountAnalysis/get-recurring-deposits';
export const GET_RECCURING_DEPOSITS_ERROR =
  '@accountAnalysis/get-recurring-deposits-error';
export const GET_RECCURING_DEPOSITS_EMPTY =
  '@accountAnalysis/get-recurring-deposits-empty';
export const GET_EMI_DEPOSITS = '@accountAnalysis/get-emi-deposits';
export const GET_EMI_DEPOSITS_ERROR =
  '@accountAnalysis/get-recurring-emi-error';
export const GET_EMI_DEPOSITS_EMPTY =
  '@accountAnalysis/get-recurring-emi-empty';
export const GET_LOANS = '@accountAnalysis/get-loans';
export const GET_LOANS_ERROR = '@accountAnalysis/get-loans-error';
export const GET_LOANS_EMPTY = '@accountAnalysis/get-loans-empty';
export const GET_SALARY = '@accountAnalysis/get-salary';
export const GET_SALARY_ERROR = '@accountAnalysis/get-salary-error';
export const GET_SALARY_EMPTY = '@accountAnalysis/get-salary-empty';
export const GET_CATEGORIES = '@accountAnalysis/get-categories';
export const GET_CATEGORIES_ERROR = '@accountAnalysis/get-categories-error';
export const GET_CATEGORIES_EMPTY = '@accountAnalysis/get-categories-empty';
export const GET_BIZ_CASHFLOW = '@account/biz-cash-flow';
export const GET_BIZ_CASHFLOW_ERROR = '@account/biz-cash-flow-error';
export const GET_BIZ_CASHFLOW_EMPTY = '@account/biz-cash-flow-empty';
export const GET_COUNTER_PARTY = '@account/biz-counter-party';
export const GET_COUNTER_PARTY_ERROR = '@account/biz-counter-party-error';
export const GET_COUNTER_PARTY_EMPTY = '@account/biz-counter-party-empty';
export const GET_ODCC_UTILIZATION = '@account/od-cc-utilization';
export const GET_ODCC_UTILIZATION_ERROR = '@account/od-cc-utilization-error';
export const GET_ODCC_UTILIZATION_EMPTY = '@account/od-cc-utilization-empty';
export const GET_TAGS = '@account/get-tags';
export const GET_TAGS_ERROR = '@account/get-tags-error';
export const GET_TAGS_EMPTY = '@account/get-tags-empty';
export const GET_CATOPTIONS = '@account/get-catoptions';
export const GET_CATOPTIONS_ERROR = '@account/get-catoptions-error';
export const GET_CATOPTIONS_EMPTY = '@account/get-catoptions-empty';
export const GET_BOUNCED_CHEQUE_STATE = '@account/get-bounced-cheque-state';
export const GET_CATEGORIES_STATE = '@account/get-categories-state';
export const GET_RECURRING_PAYMENTS_STATE =
  '@account/get-recurring-payments-state';
export const GET_RECURRING_DEPOSITS_STATE =
  '@account/get-recurring-deposits-state';
export const GET_EMI_PAYMENTS_STATE = '@account/get-emi-payments-state';
export const GET_LOANS_STATE = '@account/get-loan-state';
export const GET_SALARY_STATE = '@account/get-salary-state';
export const GET_TXNS_STATE = '@account/get-txns-state';
export const GET_SUSPICIOUS_STATE = '@account/get-suspicious-state';
export const GET_TXNS_SUMMARY_STATE = '@account/get-txns-summary-state';
export const GET_COUNTER_PARTY_STATE = '@account/get-counterparty-state';
export const GET_ODCCUTILIZATION_STATE = '@account/get-odccutilization-state';
export const EDIT_TRANSACTION = '@account/edit-transation';
export const EDIT_TRANSACTION_ERROR = '@account/edit-transaction-error';
export const ADD_TRANSACTION = '@account/add-transation';
export const ADD_TRANSACTION_ERROR = '@account/add-transaction-error';
export const ACCOUNT_TAGS = '@account/account-all-tags';
export const ACCOUNT_CATEGORIES = '@account/account-all-categories';
export const EDIT_TRANSCTION_FOR_LOCAL = '@account/edit-transaction-for-local';
export const ACCOUNT_FETCH_USER = '@account/account-modified-user';
export const EMPTY_DATA_TXNS_COUNT =
  '@accountAnalysis/get-emty-data-txns-count';
export const NEW_ADDED_TXNS = '@account/new-added-transactions';
export const EDIT_TRANSACTION_RESET = '@account/edit-transction-reset';
export const GET_TRANSACTIONS_WITH_INDEXING =
  '@account/edit-transaction-with-indexing';
export const TXNS_REF_FLAG = '@account/txns-ref-flag';
export const GET_COUNTER_PARTY_MONTHLY = '@account/counter-party-monthly';
export const GET_COUNTER_PARTY_MONTHLY_ERROR =
  '@account/counter-party-monthly-error';
export const GET_MONTHLY_COUNTERPARTY_STATE =
  '@account/monthly-counterparty-state';
export const GET_COUNTER_PARTY_MONTHLY_WITH_PAGINATION =
  '@account/monthly-counterparty-data-with-pagination';
export const ACCOUNT_ID_FOR_RE_ANALYSIS = '@account/account_id_renalaysis';
export const ACCOUNT_TAB_PERSIST = '@account/account_tab_persist';
export const ACCOUNT_TAB_PERSIST_EMPTY = '@account/account_tab_persist-empty';
export const GET_DUPLICATE_TXNS = '@accountAnalysis/get-duplicatetxn';
export const GET_DUPLICATE_TXNS_ERROR = '@accountAnalysis/get-duplicate-error';
export const GET_DUPLICATE_TXNS_STATE = '@accountAnalysis/get-duplicate-state';
export const GET_SUMMARY = '@account/get-summary';
export const GET_SUMMARY_ERROR = '@account/get-summary-error';
export const GET_SUMMARY_EMPTY = '@account/get-summary-empty';
export const GET_BUREAU_DATA_ANALYSIS = '@bureau/get-bureau-data-analysis';
export const GET_BUREAU_DATA_ANALYSIS_ERROR =
  '@bureau/get-bureau-data-analysis-error';
export const GET_BUREAU_DATA_ANALYSIS_EMPTY =
  '@bureau/get-bureau-data-analysis-empty';
export const GET_ACCOUNT_TABSCOUNT = '@account/get-tabscount';
export const GET_ACCOUNT_TABSCOUNT_ERROR = '@account/get-tabscount';
export const GET_UPI_TXNS = '@accountAnalysis/get-upiTxnsAnalysis';
export const GET_UPI_TXNS_ERROR = '@accountAnalysis/get-upiTxnsAnalysis-error';
export const GET_UPI_TXNS_EMPTY = '@accountAnalysis/get-upiTxnsAnalysis-empty';
export const GET_AML_ANALYSIS_DATA =
  '@amlanalysis/get-aml-analysis-data-for-account-id';
export const GET_AML_ANALYSIS_DATA_ERROR =
  '@amlanalysis/get-aml-analysis-data-error';
export const HIDE_LOADER = '@amlanalysis/hide-loader';

const operator = {
  greater: '>',
  greaterEqual: '>=',
  equal: '=',
  notEqual: '!=',
  less: '<',
  lessEqual: '<='
};

export function getAllTxns(
  accountID,
  pageNo,
  pageSize,
  order,
  orderBy,
  selectedFilters,
  indexRequired,
  isRowRefFlag
) {
  const createData = filters => {
    const body = filters.reduce((body, filter) => {
      if (filter[0] === 'txnType') {
        if (filter[2].includes('Debit') && filter[2].includes('Credit')) {
        } else {
          const value =
            filter[2] === 'Debit' ? 'DB' : filter[2] === 'Credit' ? 'CR' : '';
          body.transactionType = value;
        }
      }
      if (filter[0] === 'userAddedTransaction') {
        body.userAddedTransaction = true;
        body.txnsModifiedBy = filter[2].split(',');
      }
      if (filter[0] === 'txnMode') {
        const value = filter[2] === 'Cash' ? 'CASH' : filter[2];
        body.tags = value.replaceAll(', ', ':;');
      }

      if (filter[0] === 'tags' || filter[0] === 'category') {
        body[filter[0]] = filter[2].replaceAll(', ', ':;');
      }

      if (
        filter[0] === 'particulars' ||
        filter[0] === 'counterparty' ||
        filter[0] === 'chequeNumber'
      ) {
        body[filter[0]]
          ? (body[filter[0]] = body[filter[0]] + ':;' + filter[2])
          : (body[filter[0]] = filter[2]);
      }

      if (filter[0] === 'balance' || filter[0] === 'amount') {
        body[filter[0]]
          ? body[filter[0]].push({
              [filter[0]]: filter[2],
              operation: operator[filter[1]]
            })
          : (body[filter[0]] = [
              {
                [filter[0]]: filter[2],
                operation: operator[filter[1]]
              }
            ]);
      }

      if (filter[0] === 'txnDate') {
        if (
          moment(filter[2][0], 'DD/MM/YYYY').isValid() &&
          moment(filter[2][1], 'DD/MM/YYYY').isValid()
        ) {
          body.date = [
            {
              date: moment(filter[2][0], 'DD/MM/YYYY').format('YYYY-MM-DD'),
              operation: operator.greaterEqual
            },
            {
              date: moment(filter[2][1], 'DD/MM/YYYY').format('YYYY-MM-DD'),
              operation: operator.lessEqual
            }
          ];
        } else if (moment(filter[2][0], 'DD/MM/YYYY').isValid()) {
          body.date = [
            {
              date: moment(filter[2][0], 'DD/MM/YYYY').format('YYYY-MM-DD'),
              operation: operator.greaterEqual
            }
          ];
        } else if (moment(filter[2][1], 'DD/MM/YYYY').isValid()) {
          body.date = [
            {
              date: moment(filter[2][1], 'DD/MM/YYYY').format('YYYY-MM-DD'),
              operation: operator.lessEqual
            }
          ];
        }
      }
      return body;
    }, {});
    return body;
  };

  const url = `${commonURL}/transactions?accountId=${accountID}&indexRequired=${
    indexRequired ? indexRequired : null
  }&page=${pageNo}&size=${pageSize}&order=${order}&sortBy=${
    orderBy === 'debit' || orderBy === 'credit' ? 'amount' : orderBy
  }`;
  const request = helperAxios(url, 'post', createData(selectedFilters));
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response => {
        if (indexRequired) {
          // GET_TRANSACTIONS_WITH_INDEXING;
          dispatch({
            type: GET_TRANSACTIONS_WITH_INDEXING,
            payload: response.data
          });
        } else {
          dispatch({
            type: GET_TRANSACTIONS,
            payload: response.data
          });
        }
        if (isRowRefFlag) {
          dispatch({
            type: TXNS_REF_FLAG,
            payload: true
          });
        }
      })
      .catch(error => {
        dispatch({
          type: GET_TRANSACTIONS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getSuspiciousActivity(accountID, referenceNumber) {
  const url = `${commonURL}/irregularities?accountId=${accountID}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_SUSPICIOUS_ACTIVITY,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_SUSPICIOUS_ACTIVITY_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getBouncedCheque(accountID, referenceNumber) {
  const url = `${commonURL}/bouncedCheque?accountId=${accountID}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_BOUNCED_CHEQUE,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_BOUNCED_CHEQUE_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getAccountOverview(accountID) {
  const url = `${commonURL}/summary?accountId=${accountID}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_ACCOUNT_OVERVIEW,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_ACCOUNT_OVERVIEW_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getTabCounts(accountID) {
  const url = `${commonURL}/tabs?accountId=${accountID}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_ACCOUNT_TABSCOUNT,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_ACCOUNT_TABSCOUNT_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getDailyBalance(accountID) {
  const url = `${commonURL}/dailyBalance?accountId=${accountID}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response =>
        dispatch({
          type: GET_DAILY_BALANCE,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_DAILY_BALANCE_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getCirculatTransactions(accountID) {
  const url = `${commonURL}/circularTransactions?accountId=${accountID}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_CIRCULAR_TRANSACTIONS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_CIRCULAR_TRANSACTIONS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getIntraBankFundTransfer(accountID) {
  const url = `${commonURL}/intraBankFundTransfer?accountId=${accountID}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_INTRA_BANK_FUND_TRANSFER,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_INTRA_BANK_FUND_TRANSFER_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getTransactionSummary(accountID) {
  const url = `${commonURL}/transactionSummary?accountId=${accountID}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response =>
        dispatch({
          type: GET_TRANSACTION_SUMMARY,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_TRANSACTION_SUMMARY_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getCashFlow(accountID) {
  const url = `${commonURL}/cashflow?accountId=${accountID}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_CASH_FLOW,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_CASH_FLOW_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getUPITxnsAnalysis(accountID) {
  const url = `${commonURL}/UPIAnalysis?accountId=${accountID}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_UPI_TXNS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_UPI_TXNS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getClosingBalance(accountID, startDate, endDate) {
  const url = `${commonURL}/closingBalance?accountId=${accountID}&startDate=${startDate ||
    ''}&endDate=${endDate || ''}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response =>
        dispatch({
          type: GET_CLOSING_BALANCE,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_CLOSING_BALANCE_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getRecurringPayments(accountID) {
  const url = `${commonURL}/patterns?accountId=${accountID}&type=recurringPayments`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_RECCURING_PAYMENTS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_RECCURING_PAYMENTS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getRecurringDeposits(accountID) {
  const url = `${commonURL}/patterns?accountId=${accountID}&type=recurringDeposits`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_RECCURING_DEPOSITS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_RECCURING_DEPOSITS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getEmiDeposits(accountID) {
  const url = `${commonURL}/patterns?accountId=${accountID}&type=emi`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_EMI_DEPOSITS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_EMI_DEPOSITS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getLoans(accountID) {
  const url = `${commonURL}/patterns?accountId=${accountID}&type=loans`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_LOANS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_LOANS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getSalary(accountID) {
  const url = `${commonURL}/patterns?accountId=${accountID}&type=salary`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_SALARY,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_SALARY_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getCategories(accountID) {
  const url = `${commonURL}/categories?accountId=${accountID}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_CATEGORIES,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_CATEGORIES_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getBizCashFlow(accountID) {
  const url = `${commonURL}/businessCashFlow?accountId=${accountID}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_BIZ_CASHFLOW,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_BIZ_CASHFLOW_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}
export function getCounterParty(accountID) {
  const url = `${commonURL}/counterparty?accountId=${accountID}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_COUNTER_PARTY,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_COUNTER_PARTY_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}
export function getODCCUtilization(accountID) {
  const url = `${commonURL}/utilization?accountId=${accountID}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_ODCC_UTILIZATION,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_ODCC_UTILIZATION_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getCashFlowAnalysis(accountID) {
  const url = `${commonURL}/cashflowAnalysis?accountId=${accountID}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_CASH_FLOW_ANALYSIS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_CASH_FLOW_ANALYSIS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getLoanAnalysis(accountID) {
  const url = `${commonURL}/loanAnalysis?accountId=${accountID}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_LOAN_ANALYSIS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_LOAN_ANALYSIS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyODCCUtilization() {
  return dispatch => {
    dispatch({
      type: GET_ODCC_UTILIZATION_EMPTY
    });
  };
}
export function emptyCounterParty() {
  return dispatch => {
    dispatch({
      type: GET_COUNTER_PARTY_EMPTY
    });
  };
}
export function emptyBizCashFlow() {
  return dispatch => {
    dispatch({
      type: GET_BIZ_CASHFLOW_EMPTY
    });
  };
}
export function emptyRecurringPayments() {
  return dispatch => {
    dispatch({
      type: GET_RECCURING_PAYMENTS_EMPTY,
      payload: null
    });
  };
}
export function emptyRecurringDeposits() {
  return dispatch => {
    dispatch({
      type: GET_RECCURING_DEPOSITS_EMPTY,
      payload: null
    });
  };
}
export function emptyEMIDeposits() {
  return dispatch => {
    dispatch({
      type: GET_EMI_DEPOSITS_EMPTY,
      payload: null
    });
  };
}

export function emptyLoans() {
  return dispatch => {
    dispatch({
      type: GET_LOANS_EMPTY,
      payload: null
    });
  };
}

export function emptySalary() {
  return dispatch => {
    dispatch({
      type: GET_SALARY_EMPTY,
      payload: null
    });
  };
}

export function emptyCategories() {
  return dispatch => {
    dispatch({
      type: GET_CATEGORIES_EMPTY,
      payload: null
    });
  };
}

export function getSuspiciousActivityEmpty() {
  return dispatch => {
    dispatch({
      type: GET_SUSPICIOUS_ACTIVITY_EMPTY,
      payload: null
    });
  };
}
export function emptyCashFlow() {
  return dispatch => {
    dispatch({
      type: GET_CASH_FLOW_EMPTY,
      payload: null
    });
  };
}

export function emptyUPITxnsAnalysis() {
  return dispatch => {
    dispatch({
      type: GET_UPI_TXNS_EMPTY,
      payload: null
    });
  };
}

export function emptyCirculaTransactions() {
  return dispatch => {
    dispatch({
      type: GET_CIRCULAR_TRANSACTIONS_EMPTY,
      payload: null
    });
  };
}

export function emptyIntraBankFundTransfer() {
  return dispatch => {
    dispatch({
      type: GET_INTRA_BANK_FUND_TRANSFER_EMPTY,
      payload: null
    });
  };
}

export function emptyOverview() {
  return dispatch => {
    dispatch({
      type: GET_ACCOUNT_OVERVIEW_EMPTY,
      payload: null
    });
  };
}

export function emptyBouncedCheque() {
  return dispatch => {
    dispatch({
      type: GET_BOUNCED_CHEQUE_EMPTY,
      payload: null
    });
  };
}

export function emptyAnalysisData() {
  return dispatch => {
    dispatch({
      type: EMPTY_DATA,
      payload: null
    });
  };
}

export function emptyAnalysisTxnsCountData() {
  return dispatch => {
    dispatch({
      type: EMPTY_DATA_TXNS_COUNT,
      payload: null
    });
  };
}

export function emptyDailyBalance() {
  return dispatch => {
    dispatch({
      type: GET_DAILY_BALANCE_EMPTY
    });
  };
}

export function emptyTransactionSummary() {
  return dispatch => {
    dispatch({
      type: GET_TRANSACTION_SUMMARY_EMPTY
    });
  };
}

export function emptyClosingBalance() {
  return dispatch => {
    dispatch({
      type: GET_CLOSING_BALANCE_EMPTY
    });
  };
}

export function emptyTransactions() {
  return dispatch => {
    dispatch({
      type: GET_TRANSACTIONS_EMPTY
    });
  };
}

export function getTags(accountID) {
  let url = `${commonURL}/tags?accountId=${accountID}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    request
      .then(response =>
        dispatch({
          type: GET_TAGS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_TAGS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}
export function getAllBanks() {
  let url = `${commonV2URL}/bank?isFiu=${false}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    request
      .then(response => {
        dispatch({
          type: GET_BANKS,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyTags() {
  return dispatch => {
    dispatch({
      type: GET_TAGS_EMPTY
    });
  };
}

export function getCatOptions(accountID) {
  let url = `${commonURL}/uniqueCategories?accountId=${accountID}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    request
      .then(response =>
        dispatch({
          type: GET_CATOPTIONS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_CATOPTIONS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyCatOptions() {
  return dispatch => {
    dispatch({
      type: GET_CATOPTIONS_EMPTY
    });
  };
}

export function setBouncedChequeState(data) {
  return dispatch => {
    dispatch({
      type: GET_BOUNCED_CHEQUE_STATE,
      payload: data
    });
  };
}
export function setCategoriesState(data) {
  return dispatch => {
    dispatch({
      type: GET_CATEGORIES_STATE,
      payload: data
    });
  };
}

export function setRecurringPaymentsState(data) {
  return dispatch => {
    dispatch({
      type: GET_RECURRING_PAYMENTS_STATE,
      payload: data
    });
  };
}

export function setRecurringsDepositsState(data) {
  return dispatch => {
    dispatch({
      type: GET_RECURRING_DEPOSITS_STATE,
      payload: data
    });
  };
}
export function setEMIPaymentStateState(data) {
  return dispatch => {
    dispatch({
      type: GET_EMI_PAYMENTS_STATE,
      payload: data
    });
  };
}

export function setSalaryState(data) {
  return dispatch => {
    dispatch({
      type: GET_SALARY_STATE,
      payload: data
    });
  };
}
export function setLoanState(data) {
  return dispatch => {
    dispatch({
      type: GET_LOANS_STATE,
      payload: data
    });
  };
}

export function setTxnsState(data) {
  return dispatch => {
    dispatch({
      type: GET_TXNS_STATE,
      payload: data
    });
  };
}

export function setSuspiciousState(data) {
  return dispatch => {
    dispatch({
      type: GET_SUSPICIOUS_STATE,
      payload: data
    });
  };
}

export function setTxnsSummaryState(data) {
  return dispatch => {
    dispatch({
      type: GET_TXNS_SUMMARY_STATE,
      payload: data
    });
  };
}

export function setCounterpartyState(data) {
  return dispatch => {
    dispatch({
      type: GET_COUNTER_PARTY_STATE,
      payload: data
    });
  };
}

export function setOdccUtilizationState(data) {
  return dispatch => {
    dispatch({
      type: GET_ODCCUTILIZATION_STATE,
      payload: data
    });
  };
}

export function getEditTransaction(data, accountID, fromLocalComponent) {
  let url = `${commonV3URL}/account/editTransaction?accountId=${accountID}`;
  const request = helperAxios(url, 'post', data);
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response => {
        if (fromLocalComponent) {
          dispatch({
            type: EDIT_TRANSCTION_FOR_LOCAL,
            payload: response.data && response.data.message
          });
        } else {
          dispatch({
            type: EDIT_TRANSACTION,
            payload: true
          });
        }
        dispatch({
          type: SET_ALERT,
          payload:
            'Transaction updated successfully. Click Refresh button to update the Analysis.',
          payload1: 'success'
        });
      })
      .catch(error => {
        dispatch({
          type: EDIT_TRANSACTION_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getAddTransaction(data, accountID) {
  let url = `${commonV3URL}/account/addTransaction?accountId=${accountID}`;
  const request = helperAxios(url, 'put', data);
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response => {
        dispatch({
          type: NEW_ADDED_TXNS,
          payload: true
        });
        dispatch({
          type: SET_ALERT,
          payload:
            'Transaction added successfully. Click Refresh button to update the Analysis.',
          payload1: 'success'
        });
      })
      .catch(error => {
        dispatch({
          type: EDIT_TRANSACTION_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getDeleteTransaction(txnsList, accountID) {
  let url = `${commonV3URL}/account/deleteTransactions?accountId=${accountID}&txnIds=${txnsList}`;
  const request = helperAxios(url, 'delete');
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response => {
        dispatch({
          type: EDIT_TRANSACTION,
          payload: true
        });
        dispatch({
          type: SET_ALERT,
          payload:
            'Transactions deleted successfully. Click Refresh button to update the Analysis.',
          payload1: 'success'
        });
      })
      .catch(error => {
        dispatch({
          type: EDIT_TRANSACTION_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getEditTransactionFlag(data) {
  return dispatch => {
    dispatch({
      type: EDIT_TRANSACTION_RESET,
      payload: data
    });
  };
}
export function resetEditTxnsLocal() {
  return dispatch => {
    dispatch({
      type: EDIT_TRANSCTION_FOR_LOCAL,
      payload: null
    });
  };
}

export function getAccountTags(accountID) {
  let url = `${commonURL}/fetchEntities?type=tags`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    request
      .then(response =>
        dispatch({
          type: ACCOUNT_TAGS,
          payload: response.data
        })
      )
      .catch(error => {});
  };
}

export function getAccountCategories(accountID) {
  let url = `${commonURL}/fetchEntities?type=categories`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    request
      .then(response =>
        dispatch({
          type: ACCOUNT_CATEGORIES,
          payload: response.data
        })
      )
      .catch(error => {});
  };
}

export function getTxnsModifieduser(accountID) {
  let url = `${commonV3URL}/account/fetchUsers?accountId=${accountID}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    request
      .then(response =>
        dispatch({
          type: ACCOUNT_FETCH_USER,
          payload: response.data.user
        })
      )
      .catch(error => {});
  };
}

export function getTxnsRowRefFlag(data) {
  return dispatch => {
    dispatch({
      type: TXNS_REF_FLAG,
      payload: data
    });
  };
}

export function getMonthlyCounterParty(accountID) {
  const url = `${commonURL}/monthlyCounterparty?accountId=${accountID}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        if (response.data.isReanalysisRequired) {
          dispatch({
            type: ACCOUNT_ID_FOR_RE_ANALYSIS,
            payload: accountID
          });
          dispatch({
            type: SET_ALERT,
            payload: errorMessage.reAnalysisMessage,
            payload1: 'error'
          });
        } else {
          dispatch({
            type: GET_COUNTER_PARTY_MONTHLY,
            payload: response.data
          });
        }
      })
      .catch(error => {
        dispatch({
          type: GET_COUNTER_PARTY_MONTHLY_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getMonthlyCounterPartyWithPagination(monthlyData, pagination) {
  const url = `${commonURL}/customAnalysisFilters?page=${
    pagination.page
  }&size=${pagination.rowsPerPage}&order=${
    pagination.orderBy === '' ? '' : pagination.order
  }&sortBy=${pagination.orderBy}&search=${pagination.query}&showOnly=${
    pagination.txnsType === 'Debit And Credit' ? 'both' : pagination.txnsType
  }&for=mnthlycpt`;
  const request = helperAxios(url, 'post', monthlyData);
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: GET_COUNTER_PARTY_MONTHLY_WITH_PAGINATION,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: GET_COUNTER_PARTY_MONTHLY_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function setMonthlyCounterpartyState(data) {
  return dispatch => {
    dispatch({
      type: GET_MONTHLY_COUNTERPARTY_STATE,
      payload: data
    });
  };
}

export function setAccountTabPersist(tabName, accountId) {
  return dispatch => {
    dispatch({
      type: ACCOUNT_TAB_PERSIST,
      payload: tabName,
      payload1: accountId
    });
  };
}

export function setAccountTabPersistEmpty() {
  return dispatch => {
    dispatch({
      type: ACCOUNT_TAB_PERSIST_EMPTY
    });
  };
}

export function getDuplicateTxns(accountId, page, rowsPerPage) {
  const url = `${commonURL}/duplicateTxns`;
  const params = {
    accountId: accountId,
    page: page,
    size: rowsPerPage
  };
  const request = helperAxios(url, 'get', null, params);

  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response =>
        dispatch({
          type: GET_DUPLICATE_TXNS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_DUPLICATE_TXNS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function setDuplicateTxnsState(data) {
  return dispatch => {
    dispatch({
      type: GET_DUPLICATE_TXNS_STATE,
      payload: data
    });
  };
}

export function getSummary(accountId) {
  const url = `${commonURL}/customAnalysis?accountId=${accountId}&portal=1`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    // dispatch({
    //   type: LOADER
    // });
    request
      .then(response =>
        dispatch({
          type: GET_SUMMARY,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_SUMMARY_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyAgSummary() {
  return dispatch => {
    dispatch({
      type: GET_SUMMARY_EMPTY
    });
  };
}

export function getBureauDataAnalysis(cicID, referenceNumber) {
  const url = `${commonBureauURL}/analysis?cicId=${cicID}`;
  const request = helperAxios(url, 'get');
  return dispatch => {
    dispatch({ type: LOADER_BUREAU });
    request
      .then(response =>
        dispatch({
          type: GET_BUREAU_DATA_ANALYSIS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_BUREAU_DATA_ANALYSIS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function emptyBureauDataAnalysis() {
  return dispatch => {
    dispatch({
      type: GET_BUREAU_DATA_ANALYSIS_EMPTY
    });
  };
}

export function getAMLAnalysisData(accountID) {
  let url = `${commonURL}/amlAnalysis?accountId=${accountID}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response =>
        dispatch({
          type: GET_AML_ANALYSIS_DATA,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_AML_ANALYSIS_DATA_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function downloadTxnAll(
  accountID,
  pageNo,
  pageSize,
  order,
  orderBy,
  selectedFilters,
  indexRequired,
  isRowRefFlag,
  onSuccess
) {
  const createData = filters => {
    const body = filters.reduce((body, filter) => {
      if (filter[0] === 'txnType') {
        if (filter[2].includes('Debit') && filter[2].includes('Credit')) {
        } else {
          const value =
            filter[2] === 'Debit' ? 'DB' : filter[2] === 'Credit' ? 'CR' : '';
          body.transactionType = value;
        }
      }
      if (filter[0] === 'userAddedTransaction') {
        body.userAddedTransaction = true;
        body.txnsModifiedBy = filter[2].split(',');
      }
      if (filter[0] === 'txnMode') {
        const value = filter[2] === 'Cash' ? 'CASH' : filter[2];
        body.tags = value.replaceAll(', ', ':;');
      }

      if (filter[0] === 'tags' || filter[0] === 'category') {
        body[filter[0]] = filter[2].replaceAll(', ', ':;');
      }

      if (
        filter[0] === 'particulars' ||
        filter[0] === 'counterparty' ||
        filter[0] === 'chequeNumber'
      ) {
        body[filter[0]]
          ? (body[filter[0]] = body[filter[0]] + ':;' + filter[2])
          : (body[filter[0]] = filter[2]);
      }

      if (filter[0] === 'balance' || filter[0] === 'amount') {
        body[filter[0]]
          ? body[filter[0]].push({
              [filter[0]]: filter[2],
              operation: operator[filter[1]]
            })
          : (body[filter[0]] = [
              {
                [filter[0]]: filter[2],
                operation: operator[filter[1]]
              }
            ]);
      }

      if (filter[0] === 'txnDate') {
        if (
          moment(filter[2][0], 'DD/MM/YYYY').isValid() &&
          moment(filter[2][1], 'DD/MM/YYYY').isValid()
        ) {
          body.date = [
            {
              date: moment(filter[2][0], 'DD/MM/YYYY').format('YYYY-MM-DD'),
              operation: operator.greaterEqual
            },
            {
              date: moment(filter[2][1], 'DD/MM/YYYY').format('YYYY-MM-DD'),
              operation: operator.lessEqual
            }
          ];
        } else if (moment(filter[2][0], 'DD/MM/YYYY').isValid()) {
          body.date = [
            {
              date: moment(filter[2][0], 'DD/MM/YYYY').format('YYYY-MM-DD'),
              operation: operator.greaterEqual
            }
          ];
        } else if (moment(filter[2][1], 'DD/MM/YYYY').isValid()) {
          body.date = [
            {
              date: moment(filter[2][1], 'DD/MM/YYYY').format('YYYY-MM-DD'),
              operation: operator.lessEqual
            }
          ];
        }
      }
      return body;
    }, {});
    return body;
  };

  const url = `${commonURL}/transactions?accountId=${accountID}&indexRequired=${
    indexRequired ? indexRequired : null
  }&order=${order}&sortBy=${
    orderBy === 'debit' || orderBy === 'credit' ? 'amount' : orderBy
  }&fetchType=download`;
  const request = helperAxios(url, 'post', createData(selectedFilters));
  return dispatch => {
    dispatch({ type: LOADER });
    request
      .then(response => {
        if (indexRequired) {
          onSuccess(response.data);
          dispatch({
            type: HIDE_LOADER,
            payload: null
          });
        } else {
          onSuccess(response.data);
          dispatch({
            type: HIDE_LOADER,
            payload: null
          });
        }
        if (isRowRefFlag) {
          onSuccess(response.data);
          dispatch({
            type: HIDE_LOADER,
            payload: null
          });
        }
      })
      .catch(error => {
        dispatch({
          type: SET_ALERT,
          payload: 'Issue while downloading the transactions.',
          payload1: 'error'
        });
        dispatch({
          type: HIDE_LOADER,
          payload: null
        });
      });
  };
}
